import React from 'react';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <h1>Privacy Policy</h1>
      <p>Read our privacy policy</p>
    </div>
  );
};

export default Privacy;